import { render, staticRenderFns } from "./SaleCartSidebar.vue?vue&type=template&id=394b76fa&scoped=true"
import script from "./SaleCartSidebar.vue?vue&type=script&lang=js"
export * from "./SaleCartSidebar.vue?vue&type=script&lang=js"
import style0 from "./SaleCartSidebar.vue?vue&type=style&index=0&id=394b76fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b76fa",
  null
  
)

export default component.exports